export default __webpack_public_path__ + "static/media/bug.1a91d9e6.png";